var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBibliotheekIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1089.32 360.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2f1c6b;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        fill: #707e80;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-51);\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-7 {\n        opacity: .59;\n      }\n\n      .cls-7, .cls-8, .cls-9 {\n        fill: #8780a0;\n      }\n\n      .cls-10 {\n        fill: #e8d8bb;\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-43);\n      }\n\n      .cls-12 {\n        fill: #e9e4f7;\n      }\n\n      .cls-13 {\n        opacity: .5;\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-58);\n      }\n\n      .cls-16 {\n        fill: #c47dd3;\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-56);\n      }\n\n      .cls-19 {\n        opacity: .51;\n      }\n\n      .cls-19, .cls-20 {\n        fill: #6a4672;\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-40);\n      }\n\n      .cls-22 {\n        fill: #455a64;\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-52);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient-53);\n      }\n\n      .cls-30 {\n        fill: #a6a6a6;\n      }\n\n      .cls-31 {\n        opacity: .57;\n      }\n\n      .cls-31, .cls-32 {\n        fill: #442491;\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-34 {\n        fill: url(#linear-gradient-48);\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-50);\n      }\n\n      .cls-38 {\n        fill: #7a7161;\n      }\n\n      .cls-39 {\n        fill: url(#linear-gradient-39);\n      }\n\n      .cls-40 {\n        opacity: .54;\n      }\n\n      .cls-41 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-42 {\n        fill: url(#linear-gradient-59);\n      }\n\n      .cls-43 {\n        fill: url(#linear-gradient-49);\n      }\n\n      .cls-44 {\n        fill: url(#linear-gradient-37);\n      }\n\n      .cls-45 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-46 {\n        fill: #ffcf83;\n      }\n\n      .cls-47 {\n        fill: #e7d7ba;\n      }\n\n      .cls-48 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-49 {\n        fill: url(#linear-gradient-41);\n      }\n\n      .cls-50 {\n        fill: #fedb4a;\n      }\n\n      .cls-8 {\n        opacity: .49;\n      }\n\n      .cls-51 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-52 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-53 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-54 {\n        fill: url(#linear-gradient-54);\n      }\n\n      .cls-55 {\n        fill: #902df9;\n      }\n\n      .cls-56 {\n        fill: url(#linear-gradient-45);\n      }\n\n      .cls-57 {\n        fill: url(#linear-gradient-55);\n      }\n\n      .cls-58 {\n        fill: #ebebeb;\n      }\n\n      .cls-59 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-60 {\n        fill: #feb11a;\n      }\n\n      .cls-61 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-62 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 3.01px;\n      }\n\n      .cls-63 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-64 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-65 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-66 {\n        fill: url(#linear-gradient-42);\n      }\n\n      .cls-67 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-68 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-69 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-70 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-71 {\n        fill: url(#linear-gradient-38);\n      }\n\n      .cls-72 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-73 {\n        fill: #fed234;\n      }\n\n      .cls-74 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-75 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-76 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-77 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-78 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-79 {\n        fill: url(#linear-gradient-44);\n      }\n\n      .cls-80 {\n        fill: url(#linear-gradient-57);\n      }\n\n      .cls-81 {\n        fill: url(#linear-gradient-47);\n      }\n\n      .cls-82 {\n        fill: url(#linear-gradient-46);\n      }\n\n      .cls-83 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-84 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-85 {\n        fill: url(#linear-gradient-26);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 316.05,
    y1: 203.58,
    x2: 771.22,
    y2: 203.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fef7e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fef7e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 289.31,
    y1: 310.24,
    x2: 797.95,
    y2: 310.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c927f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c927f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 303.58,
    y1: 101.47,
    x2: 785.85,
    y2: 101.47,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 544.72,
    y1: 312.9,
    x2: 544.72,
    y2: 324.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7d7ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b8ad97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 544.72,
    y1: 294.6,
    x2: 544.72,
    y2: 310.03,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 432.28,
    y1: 310.2,
    x2: 444.54,
    y2: 310.2,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 439.12,
    y1: 316.73,
    x2: 451.37,
    y2: 316.73,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 615.32,
    y1: 301.08,
    x2: 627.58,
    y2: 301.08,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 622.16,
    y1: 307.61,
    x2: 634.42,
    y2: 307.61,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1010.22,
    y1: 313.47,
    x2: 1022.47,
    y2: 313.47,
    gradientTransform: "translate(1687.42) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1017.06,
    y1: 320,
    x2: 1029.31,
    y2: 320,
    gradientTransform: "translate(1687.42) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 462.87,
    y1: 301.08,
    x2: 475.13,
    y2: 301.08,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 547.39,
    y1: 238.83,
    x2: 588.34,
    y2: 238.83,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 5039.55,
    y1: 238.83,
    x2: 5080.5,
    y2: 238.83,
    gradientTransform: "translate(5586.58) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 692.6,
    y1: 221.02,
    x2: 755.68,
    y2: 221.02,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 696.18,
    y1: 211.13,
    x2: 752.04,
    y2: 211.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 712.12,
    y1: 195.03,
    x2: 715.76,
    y2: 195.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 732.46,
    y1: 195.04,
    x2: 736.09,
    y2: 195.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 610.7,
    y1: 221.02,
    x2: 673.78,
    y2: 221.02,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 614.28,
    y1: 211.13,
    x2: 670.14,
    y2: 211.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 630.22,
    y1: 195.03,
    x2: 633.86,
    y2: 195.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 650.55,
    y1: 195.04,
    x2: 654.19,
    y2: 195.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 420.64,
    y1: 221.02,
    x2: 483.72,
    y2: 221.02,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 424.23,
    y1: 211.13,
    x2: 480.09,
    y2: 211.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 440.16,
    y1: 195.03,
    x2: 443.8,
    y2: 195.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 460.5,
    y1: 195.04,
    x2: 464.13,
    y2: 195.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 339.98,
    y1: 221.02,
    x2: 403.06,
    y2: 221.02,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 343.56,
    y1: 211.13,
    x2: 399.42,
    y2: 211.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 359.5,
    y1: 195.03,
    x2: 363.13,
    y2: 195.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 379.83,
    y1: 195.04,
    x2: 383.47,
    y2: 195.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 417.24,
    y1: 125.11,
    x2: 446.28,
    y2: 125.11,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 431.76,
    y1: 278.95,
    x2: 431.76,
    y2: 291.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c927f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a7161"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 418.13,
    y1: 269.16,
    x2: 445.39,
    y2: 269.16,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 418.5,
    y1: 197.13,
    x2: 445.02,
    y2: 197.13,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 466.23,
    y1: 125.11,
    x2: 495.27,
    y2: 125.11,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 480.75,
    y1: 278.47,
    x2: 480.75,
    y2: 290.99,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 467.12,
    y1: 269.16,
    x2: 494.39,
    y2: 269.16,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 467.5,
    y1: 197.13,
    x2: 494.02,
    y2: 197.13,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 600.8,
    y1: 125.11,
    x2: 629.84,
    y2: 125.11,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 615.32,
    y1: 278.71,
    x2: 615.32,
    y2: 291.72,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 601.69,
    y1: 269.16,
    x2: 628.96,
    y2: 269.16,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 602.06,
    y1: 197.13,
    x2: 628.58,
    y2: 197.13,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 648.86,
    y1: 125.11,
    x2: 677.9,
    y2: 125.11,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 663.38,
    y1: 278.71,
    x2: 663.38,
    y2: 291.72,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 649.75,
    y1: 269.16,
    x2: 677.01,
    y2: 269.16,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 650.12,
    y1: 197.13,
    x2: 676.64,
    y2: 197.13,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 348.12,
    y1: 31.34,
    x2: 739.14,
    y2: 31.34,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 372.28,
    y1: 79.66,
    x2: 714.98,
    y2: 79.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 455.93,
    y1: 79.66,
    x2: 470.67,
    y2: 79.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 474.45,
    y1: 79.66,
    x2: 479.56,
    y2: 79.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 484,
    y1: 79.66,
    x2: 498.74,
    y2: 79.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 502.52,
    y1: 79.66,
    x2: 513.88,
    y2: 79.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 517.72,
    y1: 79.66,
    x2: 522.83,
    y2: 79.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 526.59,
    y1: 79.66,
    x2: 542.77,
    y2: 79.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 545.58,
    y1: 79.66,
    x2: 558.92,
    y2: 79.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 562.51,
    y1: 79.66,
    x2: 577.71,
    y2: 79.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 582.15,
    y1: 79.66,
    x2: 594.84,
    y2: 79.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 599.03,
    y1: 79.66,
    x2: 611.73,
    y2: 79.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 615.92,
    y1: 79.66,
    x2: 631.33,
    y2: 79.66,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m1079.04,147.92h0c-.48-1.06-1.58-1.71-2.74-1.63l-85.66,5.97c-1.21.08-2.35.62-3.18,1.51l-39.17,41.86s-3.7,6.72-.89,12.98c2.8,6.25,10.58,5.73,10.58,5.73l73.2,2.14c5.07.15,9.98-1.79,13.57-5.37l43.84-43.6c1.02-1.01,1-2.66-.03-3.65l-.99-.95-3.09,1.12-7.25-11.47,1.41-1.68c.7-.83.85-1.98.4-2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m947.38,208.61c-2.32-5.18-.19-10.68.62-12.41l83.42-2.14,12.79,17.53c-3.54,3.26-8.22,5.04-13.05,4.9l-73.2-2.14s-7.77.52-10.58-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m1024.83,211.05c-1.78-4.44-.61-9.53,2.72-12.98l49.8-51.66h0c.93.3,1.69,1.07,1.9,2.13.17.88-.15,1.79-.73,2.48l-1.23,1.47s-.04.09,0,.14l7.15,11.32s.09.06.14.05l2.93-1.06s.09,0,.12.03l.85.82c1.08,1.04,1.1,2.76.03,3.82l-43.76,43.51c-1.78,1.77-3.88,3.13-6.15,4.04-.07.03-.15.06-.22.08-1.92.74-3.96,1.15-6.05,1.21,0,0-.01,0-.02,0-4.15-.17-6.33-2.59-7.46-5.4Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m1077.22,152.56l-46.61,46.87c-2.78,2.79-3.35,7.13-1.3,10.5.03.05.06.11.1.16,3.32,5.38,10.16.53,11.2.05,1.04-.47,44.54-45.09,44.54-45.09l-7.93-12.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1034.82,210.98l28.2-29.72-30.08,28.93,10.04-11.4-11.5,9.94,16.02-19.16-17.49,17.26s.94,5.87,4.82,4.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1082.91 163.78 1070.76 174.7 1053.86 194.31 1082.91 163.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1081.37 159.1 1051.46 188.39 1066.78 170.38 1056.19 179.57 1078.43 154.47 1081.37 159.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1052.85,181.05l-14.18,14.05s12.47-9.97,14.18-14.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1033.7,208.11c.87,1.54,1.24,3.11,1.37,4.38-2.04.36-4.2-.01-5.67-2.39-.03-.05-.07-.11-.1-.16-1.25-2.06-1.52-4.47-.91-6.68,1.38.75,3.89,2.36,5.3,4.86Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1052.51 155.91 1027.95 156.96 999.85 187.88 1024.53 187.16 1052.51 155.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "948.28 195.63 949.2 194.64 1031.42 194.05 1029.51 196.04 948.28 196.61 948.28 195.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m979.82,170.92c.45,1.43,2.83,1.95,5.31,1.17,2.48-.78,4.12-2.57,3.67-4-.45-1.43-2.83-1.95-5.31-1.17-2.48.78-4.12,2.57-3.67,4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m833.26,246.96l-15.66,8.79,46.78-146.61-103.19-37.16s.22-8.06,5.82-9.18c5.6-1.12,9.12-1.37,9.12-1.37l105.04,40.71-47.9,144.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m761.19,71.98s0-.01,0-.01l2.87-7.57c.77-.76,1.72-1.35,2.95-1.59,5.6-1.12,9.12-1.37,9.12-1.37l96.79,37.51,5.28,4.7-14.79,5.15-102.22-36.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "875.52 104.57 845.8 199.9 864.51 132.87 853.23 165.56 870.54 106.3 875.52 104.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "828.5 249.63 849.9 178.12 823.6 252.38 828.5 249.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m767.66,63.69l2.43.79s2.32,4.95-6.29,7.19c0,0-1.15-.41-2.18-.84l1.89-4.99,4.15-2.15Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "836.93 248.72 833.26 246.96 878.2 103.64 770.09 64.48 776.13 61.44 884.13 101.72 836.93 248.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m820.41,256.25l46.66-147.69c.35-1.1-.24-2.28-1.33-2.66l-102.9-36.11s1.62-3.89,7.73-5.43c2.78-.7,5.73-.49,8.42.5l103.3,37.7-45.36,146.16,3.41-2.65,45.76-145.83-109.23-39.79s-13.33-2.39-21.09,9.15l-43.87,144.54,103.95,44.22c1.84.78,3.95-.19,4.55-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m755.36,70.99l.42-1.4c7.76-11.54,21.09-9.15,21.09-9.15l109.23,39.79-45.76,145.83-3.41,2.65,45.36-146.16-103.3-37.7c-2.7-.98-5.64-1.2-8.42-.5-6.11,1.54-7.73,5.43-7.73,5.43l102.9,36.11c1.09.38,1.68,1.56,1.33,2.66l-46.66,147.69c-.44,1.4-1.71,2.3-3.08,2.36l.27-2.86-1.74,2.59,46.07-150.2-106.57-37.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-62",
    x1: 826.17,
    y1: 124.74,
    x2: 770.78,
    y2: 103.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-62",
    x1: 823.6,
    y1: 134.54,
    x2: 768.21,
    y2: 113.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-62",
    x1: 821.03,
    y1: 144.33,
    x2: 765.63,
    y2: 123.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-62",
    x1: 818.45,
    y1: 154.13,
    x2: 763.06,
    y2: 132.87
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m751.84,215.15l21.86,8.49c1.51.59,3.21-.15,3.82-1.64l2.76-6.75c.64-1.56-.14-3.33-1.72-3.91l-22.38-8.25c-1.56-.58-3.29.25-3.84,1.82l-2.24,6.51c-.52,1.51.25,3.16,1.73,3.74Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 316.05,
    y: 98.72,
    width: 455.17,
    height: 209.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 289.31,
    y: 293.27,
    width: 508.63,
    height: 33.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 407.99,
    y: 293.27,
    width: 281.15,
    height: 33.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 303.58,
    y: 96.63,
    width: 482.27,
    height: 9.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 479.23,
    y: 310.24,
    width: 130.98,
    height: 16.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 488.45,
    y: 293.27,
    width: 112.54,
    height: 16.98
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 356.82,
    y: 144.01,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 363.66,
    y: 150.54,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 303.58,
    y: 301.76,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 310.42,
    y: 308.28,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 711.23,
    y: 310.2,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 704.39,
    y: 316.73,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 432.28,
    y: 307.61,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 439.12,
    y: 314.14,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 615.32,
    y: 298.49,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 622.16,
    y: 305.02,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 664.94,
    y: 310.88,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 658.1,
    y: 317.41,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 557.49,
    y: 170.37,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 564.32,
    y: 176.9,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 775.02,
    y: 305.02,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 781.86,
    y: 311.55,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 705.04,
    y: 273.81,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 711.88,
    y: 280.34,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 686.75,
    y: 144.01,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 679.91,
    y: 150.54,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 467.17,
    y: 161.37,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 460.33,
    y: 167.9,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 373.21,
    y: 173.63,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 369.79,
    y: 271.22,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 358.91,
    y: 316.14,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 462.87,
    y: 298.49,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 384.69,
    y: 301.76,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 538.82,
    y: 138.14,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 597.95,
    y: 150.54,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 726.88,
    y: 173.63,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 739.14,
    y: 298.49,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 295.32,
    y: 106.46,
    width: 498.79,
    height: 11.54
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 547.39,
    y: 184.4,
    width: 40.95,
    height: 108.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 553.48,
    y: 191.49,
    width: 28.77,
    height: 73.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 549.67,
    y: 240.88,
    width: 1.99,
    height: 12.24
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "582.25 191.49 582.25 197.94 553.48 230.66 553.48 215.16 574.28 191.49 582.25 191.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "582.25 225.3 582.25 240.78 561.09 264.9 553.48 264.9 553.48 258.06 582.25 225.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "582.25 218.5 582.25 221.77 553.48 254.54 553.48 251.26 582.25 218.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "571.4 191.49 553.48 211.86 553.48 205.45 565.76 191.49 571.4 191.49"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 553.48,
    y: 244.4,
    width: 28.77,
    height: 5.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 506.08,
    y: 184.4,
    width: 40.95,
    height: 108.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 512.17,
    y: 191.49,
    width: 28.77,
    height: 73.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 542.77,
    y: 240.88,
    width: 1.99,
    height: 12.24
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "540.94 191.49 540.94 197.94 512.17 230.66 512.17 215.16 532.97 191.49 540.94 191.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "540.94 225.3 540.94 240.78 519.78 264.9 512.17 264.9 512.17 258.06 540.94 225.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "540.94 218.5 540.94 221.77 512.17 254.54 512.17 251.26 540.94 218.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "530.09 191.49 512.17 211.86 512.17 205.45 524.45 191.49 530.09 191.49"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 512.17,
    y: 244.4,
    width: 28.77,
    height: 5.21
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m755.68,209.83v53.92h-63.08v-53.92c0-17.42,14.12-31.54,31.54-31.54s31.54,14.12,31.54,31.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m751.99,209.83v50.28h-55.81v-50.28c-.38-15.43,11.82-28.23,27.25-28.61,15.43-.38,28.23,11.82,28.61,27.25.01.45.01.91,0,1.36h-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m751.99,209.83v50.28h-55.81v-50.28c-.03-15.4,12.44-27.91,27.84-27.94.03,0,.06,0,.08,0,.9,0,1.78,0,2.64.13,8.82.83,16.72,5.81,21.28,13.4,1,1.63,1.82,3.37,2.44,5.18.37.99.66,2.02.88,3.05.45,2.03.67,4.1.65,6.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m748.03,195.42l-51.84,51.83v-18.56l42.61-42.61c3.78,2.33,6.94,5.54,9.23,9.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m751.35,203.65l-55.16,55.16v-3.93l54.28-54.28c.37.99.66,2.02.88,3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m726.74,182.02l-30.56,30.56v-2.76c0-1.83.18-3.66.53-5.46l21.95-21.95c1.79-.35,3.62-.53,5.44-.53.9,0,1.78.05,2.64.13Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 696.18,
    y: 209.31,
    width: 55.86,
    height: 3.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 712.12,
    y: 180.74,
    width: 3.64,
    height: 28.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 732.46,
    y: 180.76,
    width: 3.64,
    height: 28.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m673.78,209.83v53.92h-63.08v-53.92c0-17.42,14.12-31.54,31.54-31.54s31.54,14.12,31.54,31.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m670.09,209.83v50.28h-55.81v-50.28c-.38-15.43,11.82-28.23,27.25-28.61,15.43-.38,28.23,11.82,28.61,27.25.01.45.01.91,0,1.36h-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m670.09,209.83v50.28h-55.81v-50.28c-.03-15.4,12.44-27.91,27.84-27.94.03,0,.06,0,.08,0,.9,0,1.78,0,2.64.13,8.82.83,16.72,5.81,21.28,13.4,1,1.63,1.82,3.37,2.44,5.18.37.99.66,2.02.88,3.05.45,2.03.67,4.1.65,6.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m666.13,195.42l-51.84,51.83v-18.56l42.61-42.61c3.78,2.33,6.94,5.54,9.23,9.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m669.45,203.65l-55.16,55.16v-3.93l54.28-54.28c.37.99.66,2.02.88,3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m644.84,182.02l-30.56,30.56v-2.76c0-1.83.18-3.66.53-5.46l21.95-21.95c1.79-.35,3.62-.53,5.44-.53.9,0,1.78.05,2.64.13Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 614.28,
    y: 209.31,
    width: 55.86,
    height: 3.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 630.22,
    y: 180.74,
    width: 3.64,
    height: 28.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 650.55,
    y: 180.76,
    width: 3.64,
    height: 28.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m483.72,209.83v53.92h-63.08v-53.92c0-17.42,14.12-31.54,31.54-31.54s31.54,14.12,31.54,31.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m480.04,209.83v50.28h-55.81v-50.28c-.38-15.43,11.82-28.23,27.25-28.61,15.43-.38,28.23,11.82,28.61,27.25.01.45.01.91,0,1.36h-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m480.04,209.83v50.28h-55.81v-50.28c-.03-15.4,12.44-27.91,27.84-27.94.03,0,.06,0,.08,0,.9,0,1.78,0,2.64.13,8.82.83,16.72,5.81,21.28,13.4,1,1.63,1.82,3.37,2.44,5.18.37.99.66,2.02.88,3.05.45,2.03.67,4.1.65,6.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m476.07,195.42l-51.84,51.83v-18.56l42.61-42.61c3.78,2.33,6.94,5.54,9.23,9.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m479.39,203.65l-55.16,55.16v-3.93l54.28-54.28c.37.99.66,2.02.88,3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m454.79,182.02l-30.56,30.56v-2.76c0-1.83.18-3.66.53-5.46l21.95-21.95c1.79-.35,3.62-.53,5.44-.53.9,0,1.78.05,2.64.13Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 424.23,
    y: 209.31,
    width: 55.86,
    height: 3.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 440.16,
    y: 180.74,
    width: 3.64,
    height: 28.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 460.5,
    y: 180.76,
    width: 3.64,
    height: 28.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m403.06,209.83v53.92h-63.08v-53.92c0-17.42,14.12-31.54,31.54-31.54s31.54,14.12,31.54,31.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m399.37,209.83v50.28h-55.81v-50.28c-.38-15.43,11.82-28.23,27.25-28.61,15.43-.38,28.23,11.82,28.61,27.25.01.45.01.91,0,1.36h-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m399.37,209.83v50.28h-55.81v-50.28c-.03-15.4,12.44-27.91,27.84-27.94.03,0,.06,0,.08,0,.9,0,1.78,0,2.64.13,8.82.83,16.72,5.81,21.28,13.4,1,1.63,1.82,3.37,2.44,5.18.37.99.66,2.02.88,3.05.45,2.03.67,4.1.65,6.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m395.4,195.42l-51.84,51.83v-18.56l42.61-42.61c3.78,2.33,6.94,5.54,9.23,9.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m398.72,203.65l-55.16,55.16v-3.93l54.28-54.28c.37.99.66,2.02.88,3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m374.12,182.02l-30.56,30.56v-2.76c0-1.83.18-3.66.53-5.46l21.95-21.95c1.79-.35,3.62-.53,5.44-.53.9,0,1.78.05,2.64.13Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 343.56,
    y: 209.31,
    width: 55.86,
    height: 3.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 359.5,
    y: 180.74,
    width: 3.64,
    height: 28.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 379.83,
    y: 180.76,
    width: 3.64,
    height: 28.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 417.24,
    y: 117.08,
    width: 29.04,
    height: 16.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 411.85,
    y: 277.2,
    width: 39.82,
    height: 16.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "445.39 277.2 418.13 277.2 418.5 261.13 445.02 261.13 445.39 277.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "445.02 261.13 418.5 261.13 421.47 133.14 442.04 133.14 445.02 261.13"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 466.23,
    y: 117.08,
    width: 29.04,
    height: 16.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 460.85,
    y: 277.2,
    width: 39.82,
    height: 16.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "494.39 277.2 467.12 277.2 467.5 261.13 494.02 261.13 494.39 277.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "494.02 261.13 467.5 261.13 470.47 133.14 491.04 133.14 494.02 261.13"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 600.8,
    y: 117.08,
    width: 29.04,
    height: 16.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 595.41,
    y: 277.2,
    width: 39.82,
    height: 16.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "628.96 277.2 601.69 277.2 602.06 261.13 628.58 261.13 628.96 277.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "628.58 261.13 602.06 261.13 605.04 133.14 625.61 133.14 628.58 261.13"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 648.86,
    y: 117.08,
    width: 29.04,
    height: 16.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 643.47,
    y: 277.2,
    width: 39.82,
    height: 16.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "677.01 277.2 649.75 277.2 650.12 261.13 676.64 261.13 677.01 277.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "676.64 261.13 650.12 261.13 653.1 133.14 673.67 133.14 676.64 261.13"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "348.12 62.68 543.63 0 739.14 62.68 348.12 62.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "417.94 51.85 543.63 11.56 669.32 51.85 417.94 51.85"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 372.28,
    y: 62.68,
    width: 342.69,
    height: 33.95
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m470.67,83.29c0,2.9-2.46,4.19-6.12,4.19h-8.62v-15.64h8.4c3.65,0,5.97,1.16,5.97,4.19,0,1.97-.77,3.28-2.34,3.63,1.63.17,2.71,1.62,2.71,3.63Zm-6.69-5.33c.79,0,1.36-.52,1.36-1.42s-.57-1.43-1.43-1.43h-2.87v2.85h2.94Zm.15,6.13c.87,0,1.4-.5,1.4-1.42s-.56-1.42-1.4-1.42h-3.08v2.84h3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m479.56,87.47h-5.11v-15.64h5.11v15.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m498.74,83.29c0,2.9-2.46,4.19-6.12,4.19h-8.62v-15.64h8.4c3.65,0,5.98,1.16,5.98,4.19,0,1.97-.77,3.28-2.35,3.63,1.63.17,2.71,1.62,2.71,3.63Zm-6.69-5.33c.79,0,1.36-.52,1.36-1.42s-.57-1.43-1.43-1.43h-2.87v2.85h2.94Zm.15,6.13c.87,0,1.4-.5,1.4-1.42s-.56-1.42-1.4-1.42h-3.08v2.84h3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m513.88,83.49v3.99h-11.37v-15.64h5.11v11.65h6.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m522.83,87.47h-5.11v-15.64h5.11v15.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m526.59,79.66c0-5.47,3.16-8.13,8.07-8.13s8.1,2.66,8.1,8.13-3.17,8.13-8.1,8.13-8.07-2.66-8.07-8.13Zm8.07,4.12c1.82,0,2.98-1.26,2.98-4.12s-1.16-4.12-2.98-4.12-2.97,1.26-2.97,4.12,1.16,4.12,2.97,4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m558.92,75.82h-4.11v11.65h-5.1v-11.65h-4.12v-3.99h13.34v3.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m577.71,71.84v15.64h-5.1v-5.83h-4.98v5.83h-5.11v-15.64h5.11v5.83h4.98v-5.83h5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m587.26,75.82v2.14h6.33v3.37h-6.33v2.14h7.58v3.99h-12.7v-15.64h12.7v3.99h-7.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m604.15,75.82v2.14h6.33v3.37h-6.33v2.14h7.58v3.99h-12.7v-15.64h12.7v3.99h-7.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m621.03,78.4l4.4-6.57h5.8l-5.5,7.82,5.6,7.82h-5.9l-4.4-6.57v6.57h-5.11v-15.64h5.11v6.57Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 673.93,
    y: 72.1,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 667.1,
    y: 78.63,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 398.72,
    y: 69.51,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 422.16,
    y: 85.19,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 428.28,
    y: 78.63,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m199.16,228.01l10.7-17.61s53.99,14.02,76,32.44c0,0,.9-34.22,45.48-73.9l16.94,6.91-55.78,74-9.77,1.35h-6.45l-77.12-23.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m279.35,250.48l2.82-3.31c2.27-2.66,5.83-3.85,9.24-3.08l4.91,1.11s-5.23,4.59-8.66,5.29c-3.44.7-8.31,0-8.31,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "295.09 240.54 324.76 199.16 304.92 223.12 295.09 240.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m337,181.38l-27.08,32.42s18.91-28.33,27.08-32.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m291.64,239.85l16.68-33.46s-14.61,19.14-16.68,33.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "339.45 172.25 316.31 197.6 333.73 176.55 322 187.08 335.33 170.57 339.45 172.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "343.34 173.84 338.44 179.49 344.7 174.39 343.34 173.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "208.36 212.88 247.96 225.78 210.16 215.8 223.41 222.17 206.16 216.49 208.36 212.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m239.59,229.1l34.13,11.44s-25.81-11.87-34.13-11.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "203.17 227.14 224.66 231.25 252.8 241.98 203.17 227.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "276.76 246.82 243.63 236.13 263.85 240.54 276.76 246.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m218.35,224.79l26.84,9.77s-24.26-6.18-26.84-9.77Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m391.04,273.5l-38.43-99.86c-.69-1.79-3.07-2.12-4.23-.6l-51.45,67.97c-.2,1.02-.58,1.98-1.16,2.9-.7,1.12-1.48,2.24-2.44,3.15-.74.71-1.67,1.38-2.51,1.96-.16.11-.32.21-.5.31-2.31,1.27-4.94,1.95-7.58,1.87-.02,0-.04,0-.06,0-.03,0-.05,0-.07,0-2.91,0-5.21-.92-6.93-2.38l-79.42-23.76c-1.93-.58-3.7,1.31-2.99,3.2l37.5,100.27c1.51,4.04,4.92,7.08,9.1,8.11l82.15,20.38c10.84,3.5,16.44-5.95,16.44-5.95l50.69-64.81c2.83-3.62,3.56-8.47,1.9-12.76Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m295.76,243.91c-.7,1.12-1.48,2.24-2.44,3.15-.74.71-1.67,1.38-2.51,1.96-.16.11-.32.21-.5.31-2.31,1.27-4.94,1.95-7.58,1.87-.02,0-.04,0-.06,0-.03,0-.05,0-.07,0-1.66,0-3.12-.31-4.39-.84l43.79,106.65c10.84,3.5,16.44-5.95,16.44-5.95l-42.49-107.48c-.06.11-.12.22-.19.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m280.59,256.17l38.86,94.64-21.89-43.86c-2.08-4.17-3.82-8.5-5.2-12.94l-11.77-37.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m337.2,347.94l-31.85-80.58,24.61,54.89c3.66,8.16,6.1,16.81,7.25,25.68h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m298,246.21l54.52-72.73c-.77-1.63-3.02-1.91-4.14-.43l-54.01,71.35c-8.47,6.92-17.14,4.9-17.14,4.9l-80.99-24.23c-1.93-.58-3.7,1.31-2.99,3.2l84.84,25.08s11.29,2.67,19.91-7.13Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m311.87,248.46l37.45-48.84c.58-.75,1.76-.55,2.06.34l8.86,26.49c.13.38.05.79-.19,1.1l-36.41,46.6c-.56.72-1.68.56-2.03-.28l-9.9-24.24c-.16-.39-.1-.83.16-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m333.04,271.65l23.86-29.01c.76-.92,2.21-.78,2.78.27l1.67,3.09c.33.6.26,1.34-.18,1.87l-23.94,29.21c-.78.95-2.29.77-2.82-.34l-1.59-3.3c-.28-.59-.2-1.29.22-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m357.21,311.28l11.43-14.9c.36-.47,1.09-.43,1.4.09l.89,1.52c.17.3.15.67-.06.94l-11.47,15c-.37.49-1.13.42-1.42-.12l-.85-1.62c-.15-.29-.12-.64.08-.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m259.59,266.38c-.08,0-.17,0-.26-.03l-38.29-9.31c-.58-.14-.93-.72-.79-1.3.14-.58.72-.93,1.3-.79l38.29,9.31c.58.14.93.72.79,1.3-.12.49-.56.82-1.04.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m262.78,273.28c-.08,0-.17,0-.26-.03l-38.29-9.31c-.58-.14-.93-.72-.79-1.3.14-.58.73-.93,1.3-.79l38.29,9.31c.58.14.93.72.79,1.3-.12.49-.56.82-1.04.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m265.97,280.18c-.08,0-.17,0-.26-.03l-38.29-9.31c-.58-.14-.93-.72-.79-1.3.14-.58.72-.93,1.3-.79l38.29,9.31c.58.14.93.72.79,1.3-.12.49-.56.82-1.04.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m269.16,287.08c-.08,0-.17,0-.26-.03l-38.29-9.31c-.58-.14-.93-.72-.79-1.3.14-.58.72-.93,1.3-.79l38.29,9.31c.58.14.93.72.79,1.3-.12.49-.56.82-1.04.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m272.35,293.98c-.08,0-.17,0-.26-.03l-38.29-9.31c-.58-.14-.93-.72-.79-1.3.14-.58.72-.93,1.3-.79l38.29,9.31c.58.14.93.72.79,1.3-.12.49-.56.82-1.04.82Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m8.81,245.19h0c.36-1.44,1.58-2.51,3.05-2.68l108.56-12.35c1.54-.17,3.08.24,4.33,1.16l58.7,43.31s6.18,7.56,4.12,16.03-11.91,9.62-11.91,9.62l-91.09,19.62c-6.31,1.36-12.9.07-18.23-3.58L1.42,271.91c-1.51-1.03-1.87-3.1-.8-4.58l1.02-1.41,4.12.69,6.41-16.03-2.16-1.78c-1.06-.87-1.53-2.28-1.19-3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m187.58,290.65c1.71-7.02-2.24-13.4-3.64-15.39l-104.87,16.63-11.94,24.89c5.19,3.26,11.45,4.41,17.46,3.11l91.09-19.62s9.85-1.15,11.91-9.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m91.25,311.64c1.21-5.97-1.45-12.07-6.4-15.61L10.59,242.92h0c-1.1.59-1.87,1.73-1.88,3.1-.01,1.14.61,2.21,1.49,2.93l1.88,1.55s.07.11.04.17l-6.33,15.82c-.03.06-.09.1-.16.09l-3.92-.65c-.05,0-.11.01-.14.06l-.87,1.22c-1.11,1.55-.73,3.71.84,4.78l64.82,44.32c2.63,1.8,5.57,3.02,8.64,3.64.1.02.2.04.3.05,2.57.48,5.23.52,7.85.12,0,0,.01,0,.02,0,5.15-1.17,7.32-4.7,8.08-8.48Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m12.16,250.58l69.17,47.86c4.12,2.85,5.84,8.15,4.06,12.84-.03.07-.06.15-.09.22-2.91,7.49-12.59,3.01-14,2.66S5.13,268.05,5.13,268.05l7.03-17.47Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m78.73,313.85l-42.16-30.66,44.33,29.23-15.2-11.94,16.69,9.77-24.47-20.26,25.87,17.55s.18,7.56-5.07,6.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "7.63 265.93 25.36 276.78 51.05 297.41 7.63 265.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "8.48 259.72 52.68 289.45 29.34 270.45 44.72 279.5 11.09 253.24 8.48 259.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m49.24,280.58l20.99,14.29s-17.91-9.59-20.99-14.29Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m79.47,310c-.74,2.13-.83,4.17-.71,5.8,2.64-.02,5.25-.99,6.54-4.3.03-.07.06-.15.09-.22,1.09-2.86.86-5.95-.41-8.57-1.55,1.25-4.32,3.86-5.51,7.3Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "43.85 249.04 74.83 244.68 117.13 276.86 86.08 281.67 43.85 249.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "183.46 274.62 182.07 273.6 79.06 291.89 81.91 293.93 183.68 275.86 183.46 274.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m138.28,251.01c-.23,1.89-3.09,3.09-6.37,2.69s-5.76-2.27-5.52-4.16c.23-1.89,3.09-3.09,6.37-2.69s5.76,2.27,5.52,4.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m90.74,130.64l-8.8,1.41c-1.37.22-2.19,1.64-1.7,2.94l24.71,65.24c.78,2.05,3.11,3.04,5.12,2.16,9.91-4.35,37.45-15.47,52.39-11.73l14.11-3.74s19.67-20.2,51.99-17.07c1.41.14,2.43-1.32,1.8-2.59l-24.99-50.03-87.27,13.43h-27.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m80.24,134.98l24.71,65.24c.78,2.05,3.11,3.04,5.12,2.16,9.91-4.35,37.45-15.47,52.39-11.73l14.11-3.74s19.67-20.2,51.99-17.07c1.01.1,1.8-.62,1.95-1.5-28.41-7.43-54.71,16.78-54.71,16.78l-12.78,3.24c-20.59-4.58-54.92,11.63-54.92,11.63l-26.17-67.94c-1.37.22-2.19,1.64-1.7,2.94Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m85.04,135.11l24.82,62.43s29.84-15.29,52.4-10.53c0,0,1.5-4.51,5.01-5.01,3.51-.5,7.02,2.26,7.02,2.26,0,0,21.8-24.14,51.64-17.5l3.38-10.92-25.86-50.5s-38.88-2.83-56.51,19.01c0,0-21.85-12.71-54.64,2.96l-7.27,7.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m109.87,197.54s29.84-15.29,52.4-10.53c0,0,1.5-4.51,5.01-5.01,3.51-.5,7.02,2.26,7.02,2.26,0,0,21.8-24.14,51.64-17.5l3.38-10.92c-41.88-8.04-63.36,23.38-63.36,23.38-24.32-11.71-50.89,3.6-50.89,3.6l-22.75-55.51-7.27,7.81,24.82,62.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "115.07 182.81 109.87 197.54 85.04 135.11 92.31 127.3 115.07 182.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m146.95,124.34l19.01,54.87-7.13-15.97c-4.86-10.88-8.5-22.25-10.87-33.93l-1.01-4.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m174.3,184.25s-6.3-.07-7.4,0c-1.1.07-4.64,2.76-4.64,2.76,0,0,1.62-4.91,5.01-5.01,3.39-.11,5.23.77,7.02,2.26Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m100.06,131.22c3.32-1.57,6.81-2.74,10.35-3.73,3.54-.98,7.16-1.72,10.83-2.11,3.67-.35,7.39-.45,11.06.02.92.12,1.82.33,2.73.48.45.1.91.15,1.36.28l1.33.4c1.79.48,3.45,1.3,5.1,2.09-1.75-.57-3.42-1.28-5.23-1.58l-1.32-.32c-.44-.1-.9-.13-1.35-.2-.9-.11-1.79-.26-2.7-.33-3.62-.27-7.25-.14-10.86.23-3.61.36-7.19,1.06-10.75,1.83-.89.19-1.78.4-2.66.64-.89.22-1.77.46-2.64.71-1.77.46-3.51,1.01-5.25,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m102.1,135.88c3.32-1.57,6.81-2.74,10.35-3.73,3.54-.98,7.16-1.72,10.83-2.11,3.67-.35,7.38-.45,11.06.02.92.12,1.82.33,2.73.48.45.1.91.15,1.36.28l1.33.4c1.79.48,3.45,1.3,5.1,2.09-1.75-.57-3.42-1.28-5.23-1.58l-1.32-.32c-.44-.1-.9-.13-1.35-.2-.9-.11-1.79-.26-2.7-.33-3.62-.27-7.25-.14-10.86.23-3.61.36-7.19,1.06-10.75,1.83-.89.19-1.78.4-2.66.64-.89.22-1.77.46-2.64.71-1.77.46-3.51,1.01-5.25,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m104.14,140.53c3.32-1.57,6.81-2.74,10.35-3.73,3.54-.98,7.16-1.72,10.84-2.11,3.67-.35,7.38-.45,11.06.02.92.12,1.82.33,2.73.48.45.1.91.15,1.36.28l1.33.4c1.79.48,3.45,1.3,5.1,2.09-1.75-.57-3.42-1.28-5.23-1.58l-1.32-.32c-.44-.1-.9-.13-1.35-.2-.9-.11-1.79-.26-2.7-.33-3.62-.27-7.25-.14-10.86.23-3.61.36-7.19,1.06-10.75,1.83-.89.19-1.78.4-2.66.63-.89.22-1.77.46-2.64.71-1.77.46-3.51,1.01-5.25,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m106.18,145.19c3.32-1.57,6.81-2.74,10.35-3.73,3.54-.98,7.16-1.72,10.83-2.11,3.67-.35,7.39-.45,11.06.02.92.12,1.82.33,2.73.48.45.1.91.15,1.35.28l1.33.4c1.79.48,3.45,1.3,5.1,2.09-1.75-.57-3.42-1.28-5.23-1.58l-1.32-.32c-.44-.1-.9-.13-1.35-.2-.9-.11-1.79-.26-2.7-.33-3.62-.27-7.25-.14-10.86.23-3.61.36-7.19,1.06-10.75,1.83-.89.19-1.78.4-2.66.63-.89.22-1.77.46-2.64.71-1.77.46-3.51,1.01-5.25,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m108.22,149.85c3.32-1.57,6.81-2.74,10.35-3.73,3.54-.98,7.16-1.72,10.83-2.11,3.67-.35,7.39-.45,11.06.02.92.12,1.82.33,2.73.48.45.1.91.15,1.35.28l1.33.4c1.79.48,3.45,1.3,5.1,2.09-1.75-.57-3.42-1.28-5.23-1.58l-1.32-.32c-.44-.1-.9-.13-1.35-.2-.9-.11-1.79-.26-2.7-.33-3.62-.27-7.25-.14-10.86.23-3.61.36-7.19,1.06-10.75,1.83-.89.19-1.78.4-2.66.64-.89.22-1.77.46-2.64.71-1.77.46-3.51,1.01-5.25,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m110.26,154.51c3.32-1.57,6.81-2.74,10.35-3.73,3.54-.98,7.16-1.72,10.83-2.11,3.67-.35,7.39-.45,11.06.02.92.12,1.82.33,2.73.48.45.1.91.15,1.35.28l1.33.4c1.79.48,3.45,1.3,5.1,2.09-1.75-.57-3.42-1.28-5.23-1.58l-1.32-.32c-.44-.1-.9-.13-1.35-.2-.9-.11-1.79-.26-2.7-.33-3.62-.27-7.25-.14-10.86.23-3.61.36-7.19,1.06-10.75,1.83-.89.19-1.78.4-2.66.64-.89.22-1.77.46-2.64.71-1.77.46-3.51,1.01-5.25,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m112.3,159.16c3.16-1.55,6.51-2.73,9.89-3.72,3.4-.97,6.87-1.69,10.39-2.11,3.53-.32,7.1-.44,10.63.02.88.12,1.75.33,2.62.48.43.1.88.15,1.3.28l1.27.4c1.71.47,3.3,1.3,4.87,2.08-1.68-.56-3.27-1.28-5-1.58l-1.27-.32c-.42-.11-.86-.13-1.29-.2-.86-.11-1.72-.26-2.59-.33-3.47-.28-6.96-.17-10.42.23-3.47.33-6.9,1.05-10.3,1.84-.85.19-1.7.4-2.55.64-.85.22-1.69.46-2.53.71-1.69.47-3.36,1.01-5.03,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m114.25,163.82c3.16-1.56,6.51-2.73,9.89-3.72,3.4-.97,6.87-1.69,10.39-2.11,3.53-.32,7.1-.44,10.63.02.88.12,1.75.33,2.62.48.43.1.88.15,1.3.28l1.27.4c1.71.47,3.3,1.3,4.87,2.08-1.68-.56-3.27-1.28-5-1.58l-1.27-.32c-.42-.11-.86-.13-1.29-.2-.86-.11-1.72-.26-2.59-.33-3.47-.28-6.96-.17-10.42.23-3.47.33-6.9,1.05-10.3,1.84-.85.19-1.7.4-2.55.64-.85.22-1.69.46-2.53.71-1.69.47-3.36,1.01-5.03,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m116.21,168.48c3.16-1.55,6.51-2.73,9.89-3.72,3.4-.97,6.87-1.69,10.39-2.11,3.53-.32,7.1-.44,10.63.02.88.12,1.75.33,2.62.48.43.1.88.15,1.3.28l1.27.4c1.71.47,3.3,1.3,4.87,2.08-1.68-.56-3.27-1.28-5-1.58l-1.27-.32c-.42-.11-.86-.13-1.29-.2-.86-.11-1.72-.26-2.59-.33-3.47-.28-6.96-.17-10.42.23-3.47.33-6.9,1.05-10.3,1.84-.85.19-1.7.4-2.55.64-.85.22-1.69.46-2.53.71-1.69.47-3.36,1.01-5.03,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m118.49,173.04c3.16-1.56,6.51-2.73,9.89-3.72,3.4-.97,6.87-1.69,10.39-2.11,3.53-.32,7.1-.44,10.63.02.88.12,1.75.33,2.62.48.43.1.88.15,1.3.28l1.27.4c1.71.47,3.3,1.3,4.87,2.08-1.68-.56-3.27-1.28-5-1.58l-1.27-.32c-.42-.11-.86-.13-1.29-.2-.86-.11-1.72-.26-2.59-.33-3.47-.28-6.96-.17-10.42.23-3.47.33-6.9,1.05-10.3,1.84-.85.19-1.7.4-2.55.64-.85.22-1.69.46-2.53.71-1.69.47-3.36,1.01-5.03,1.58Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m167.77,167.72c3.2-3.32,6.89-6.16,10.77-8.68,3.88-2.53,8.05-4.6,12.34-6.35,2.14-.9,4.38-1.53,6.58-2.25,2.26-.52,4.48-1.23,6.78-1.5,4.56-.86,9.22-.94,13.81-.74-1.15.08-2.3.15-3.45.21-1.15.06-2.29.11-3.43.3l-3.41.42c-1.13.16-2.25.44-3.37.65-2.25.4-4.44,1.07-6.66,1.63-2.16.74-4.36,1.39-6.45,2.31-4.27,1.64-8.37,3.69-12.3,6.04-.98.58-1.95,1.21-2.92,1.81-.95.64-1.9,1.28-2.84,1.94-1.89,1.31-3.7,2.72-5.45,4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m166.48,163.17c3.02-3.27,6.52-6.09,10.21-8.6,3.69-2.52,7.68-4.59,11.8-6.34,2.05-.91,4.2-1.54,6.32-2.26l3.25-.84c.54-.13,1.08-.3,1.63-.4l1.66-.27c4.39-.88,8.9-.95,13.33-.75-1.11.08-2.22.15-3.33.2l-1.66.09c-.55.03-1.1.14-1.65.21l-3.29.42c-1.09.17-2.17.44-3.25.65-2.17.39-4.28,1.08-6.41,1.64-2.08.75-4.18,1.4-6.19,2.32-4.09,1.65-8.01,3.7-11.76,6.04l-2.78,1.8c-.9.64-1.81,1.27-2.7,1.93-1.8,1.3-3.52,2.69-5.18,4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m165.18,158.62c3.02-3.27,6.52-6.09,10.21-8.6,3.69-2.52,7.68-4.59,11.8-6.34,2.05-.91,4.2-1.54,6.32-2.26l3.25-.84c.54-.13,1.08-.3,1.63-.4l1.66-.27c4.39-.88,8.9-.95,13.33-.75-1.11.08-2.22.15-3.33.2l-1.66.09c-.55.03-1.1.14-1.65.21l-3.29.42c-1.09.17-2.17.44-3.25.65-2.17.39-4.28,1.08-6.41,1.64-2.08.75-4.18,1.4-6.19,2.32-4.09,1.65-8.01,3.7-11.76,6.04l-2.78,1.8c-.9.64-1.81,1.27-2.7,1.93-1.8,1.3-3.52,2.69-5.18,4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m163.89,154.07c3.02-3.27,6.52-6.09,10.21-8.6,3.69-2.52,7.68-4.59,11.8-6.34,2.05-.91,4.2-1.54,6.32-2.26l3.25-.84c.54-.13,1.08-.3,1.63-.4l1.66-.27c4.39-.88,8.9-.95,13.33-.75-1.11.08-2.22.15-3.33.2l-1.66.09c-.55.03-1.1.14-1.65.21l-3.29.42c-1.09.17-2.17.44-3.25.65-2.17.39-4.28,1.08-6.41,1.64-2.08.75-4.18,1.4-6.19,2.32-4.09,1.65-8.01,3.7-11.76,6.04l-2.78,1.8c-.9.64-1.81,1.27-2.7,1.93-1.8,1.3-3.52,2.69-5.18,4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m161.51,149.39c3.02-3.27,6.52-6.09,10.21-8.6,3.69-2.52,7.68-4.59,11.8-6.34,2.05-.91,4.2-1.54,6.32-2.26l3.25-.84c.54-.13,1.08-.3,1.63-.4l1.66-.27c4.39-.88,8.9-.95,13.33-.75-1.11.08-2.22.15-3.33.2l-1.66.09c-.55.03-1.1.14-1.65.21l-3.29.42c-1.09.17-2.17.44-3.25.65-2.17.39-4.28,1.08-6.41,1.64-2.08.75-4.18,1.4-6.19,2.32-4.09,1.65-8.01,3.7-11.76,6.04l-2.78,1.8c-.9.64-1.81,1.27-2.7,1.93-1.8,1.3-3.52,2.69-5.18,4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m159.16,146.09c3.02-3.27,6.52-6.09,10.21-8.6,3.69-2.52,7.68-4.59,11.8-6.34,2.05-.91,4.2-1.54,6.32-2.26l3.25-.84c.54-.13,1.08-.3,1.63-.4l1.66-.27c4.39-.88,8.9-.95,13.33-.75-1.11.08-2.22.15-3.33.2l-1.66.09c-.55.03-1.1.14-1.65.21l-3.29.42c-1.09.17-2.17.44-3.25.65-2.17.39-4.28,1.08-6.41,1.64-2.08.75-4.18,1.4-6.19,2.32-4.09,1.65-8.01,3.7-11.76,6.04l-2.78,1.8c-.9.64-1.81,1.27-2.7,1.93-1.8,1.3-3.52,2.69-5.18,4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m157.86,141.54c3.02-3.27,6.52-6.09,10.21-8.6,3.69-2.52,7.68-4.59,11.8-6.34,2.05-.91,4.2-1.54,6.32-2.26l3.25-.84c.54-.13,1.08-.3,1.63-.4l1.66-.27c4.39-.88,8.9-.95,13.33-.75-1.11.08-2.22.15-3.33.2l-1.66.09c-.55.03-1.1.14-1.65.21l-3.29.42c-1.09.17-2.17.44-3.25.65-2.17.39-4.28,1.08-6.41,1.64-2.08.75-4.18,1.4-6.19,2.32-4.09,1.65-8.01,3.7-11.76,6.04l-2.78,1.8c-.9.64-1.81,1.27-2.7,1.93-1.8,1.3-3.52,2.69-5.18,4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m154.06,132.65c2.89-3.23,6.26-6.04,9.82-8.54,3.57-2.5,7.42-4.58,11.41-6.34,1.99-.9,4.08-1.55,6.14-2.27l3.16-.85c.53-.13,1.05-.3,1.58-.4l1.61-.27c4.28-.89,8.67-.96,12.99-.77-1.08.08-2.16.15-3.24.2l-1.62.09c-.54.03-1.07.14-1.6.21l-3.2.42c-1.06.18-2.11.44-3.16.66-1.05.22-2.1.45-3.13.77l-3.1.88c-2.02.74-4.06,1.41-6.01,2.32-3.96,1.66-7.76,3.71-11.38,6.04l-2.69,1.8c-.87.64-1.75,1.26-2.6,1.92-1.73,1.29-3.39,2.68-4.99,4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m151.99,128.49c2.89-3.23,6.26-6.04,9.82-8.54,3.57-2.5,7.42-4.58,11.41-6.34,1.99-.9,4.08-1.55,6.14-2.27l3.16-.85c.53-.13,1.05-.3,1.58-.4l1.61-.27c4.28-.89,8.67-.96,12.99-.77-1.08.08-2.16.15-3.24.2l-1.62.09c-.54.03-1.07.14-1.6.21l-3.2.42c-1.06.18-2.11.44-3.16.66-1.05.22-2.1.45-3.13.77l-3.1.88c-2.02.74-4.06,1.41-6.01,2.32-3.96,1.66-7.76,3.71-11.38,6.04l-2.69,1.8c-.87.64-1.75,1.26-2.6,1.92-1.73,1.29-3.39,2.68-4.99,4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m156.57,136.99c2.92-3.24,6.32-6.05,9.91-8.55,3.59-2.51,7.48-4.58,11.5-6.34,2-.9,4.11-1.55,6.18-2.27l3.18-.85c.53-.13,1.06-.3,1.59-.4l1.62-.27c4.3-.88,8.72-.95,13.07-.76-1.09.08-2.18.15-3.26.2l-1.63.09c-.54.03-1.08.14-1.61.21l-3.22.42c-1.07.17-2.12.44-3.18.65-1.06.22-2.11.45-3.15.76l-3.12.88c-2.03.74-4.09,1.4-6.05,2.32-3.99,1.65-7.82,3.71-11.47,6.04l-2.71,1.8c-.87.64-1.76,1.26-2.62,1.92-1.75,1.29-3.42,2.68-5.03,4.15Z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m1000.28,245.21l14.05,2.25c2.19.35,3.5,2.62,2.71,4.69l-39.46,104.16c-1.24,3.27-4.96,4.85-8.17,3.44-15.82-6.94-59.79-24.69-83.64-18.73l-22.53-5.98s-31.4-32.25-83.01-27.26c-2.26.22-3.88-2.11-2.87-4.14l39.89-79.88,139.33,21.45h43.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m1017.05,252.14l-39.46,104.16c-1.24,3.27-4.96,4.85-8.17,3.44-15.82-6.94-59.79-24.69-83.64-18.73l-22.53-5.98s-31.4-32.25-83.01-27.26c-1.61.16-2.88-.99-3.11-2.4,45.36-11.86,87.34,26.79,87.34,26.79l20.4,5.18c32.88-7.31,87.67,18.57,87.67,18.57l41.79-108.47c2.18.35,3.5,2.62,2.71,4.69Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m1009.38,252.33l-39.63,99.67s-47.64-24.42-83.66-16.81c0,0-2.4-7.21-8.01-8.01-5.6-.8-11.21,3.6-11.21,3.6,0,0-34.81-38.54-82.44-27.94l-5.4-17.44,41.29-80.63s62.08-4.51,90.22,30.35c0,0,34.89-20.3,87.23,4.72l11.61,12.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m969.75,352.01s-47.64-24.42-83.66-16.81c0,0-2.4-7.21-8.01-8.01-5.6-.8-11.21,3.6-11.21,3.6,0,0-34.81-38.54-82.44-27.94l-5.4-17.44c66.86-12.84,101.16,37.32,101.16,37.32,38.83-18.7,81.25,5.75,81.25,5.75l36.33-88.63,11.61,12.47-39.63,99.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "961.45 328.5 969.75 352.01 1009.38 252.33 997.78 239.86 961.45 328.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m910.54,235.14l-30.35,87.6,11.38-25.49c7.75-17.36,13.57-35.53,17.36-54.16l1.61-7.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m866.88,330.79s10.06-.11,11.81,0c1.76.11,7.4,4.4,7.4,4.4,0,0-2.59-7.83-8.01-8.01-5.41-.17-8.36,1.23-11.21,3.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m985.42,246.13c-5.3-2.5-10.88-4.38-16.53-5.96-5.66-1.56-11.44-2.74-17.3-3.36-5.86-.55-11.79-.72-17.66.03-1.46.18-2.91.52-4.36.77-.72.15-1.46.24-2.16.44l-2.12.64c-2.85.76-5.51,2.08-8.14,3.34,2.8-.9,5.47-2.05,8.35-2.52l2.11-.5c.7-.17,1.43-.21,2.15-.32,1.44-.17,2.86-.42,4.31-.52,5.77-.43,11.57-.22,17.33.36,5.77.57,11.48,1.68,17.16,2.93,1.42.31,2.84.64,4.25,1.01,1.41.35,2.82.73,4.22,1.14,2.82.74,5.61,1.61,8.39,2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m982.16,253.56c-5.3-2.5-10.88-4.38-16.53-5.96-5.66-1.56-11.44-2.74-17.3-3.36-5.86-.55-11.79-.72-17.66.03-1.46.18-2.91.52-4.36.77-.72.15-1.46.24-2.16.44l-2.12.64c-2.85.76-5.51,2.08-8.14,3.34,2.8-.9,5.47-2.05,8.35-2.52l2.11-.5c.7-.17,1.43-.21,2.15-.32,1.44-.17,2.86-.42,4.31-.52,5.77-.43,11.57-.22,17.33.36,5.77.57,11.48,1.68,17.16,2.93,1.42.31,2.84.64,4.25,1.01,1.41.35,2.82.73,4.22,1.14,2.82.74,5.61,1.61,8.39,2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m978.9,261c-5.3-2.5-10.88-4.38-16.53-5.96-5.66-1.56-11.44-2.74-17.3-3.36-5.86-.55-11.79-.72-17.66.03-1.46.18-2.91.52-4.36.77-.72.15-1.45.24-2.16.44l-2.12.64c-2.85.76-5.51,2.08-8.14,3.34,2.8-.9,5.47-2.05,8.35-2.52l2.11-.5c.7-.17,1.43-.21,2.15-.32,1.44-.17,2.86-.42,4.31-.52,5.77-.43,11.57-.22,17.33.36,5.77.57,11.48,1.68,17.16,2.93,1.42.31,2.84.64,4.25,1.01,1.41.35,2.82.73,4.22,1.14,2.82.74,5.61,1.61,8.39,2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m975.64,268.44c-5.3-2.5-10.88-4.38-16.53-5.96-5.66-1.56-11.44-2.74-17.3-3.36-5.86-.55-11.79-.72-17.66.03-1.46.18-2.91.52-4.36.77-.72.15-1.45.24-2.16.44l-2.12.64c-2.85.76-5.51,2.08-8.14,3.34,2.8-.9,5.47-2.05,8.35-2.52l2.11-.5c.7-.17,1.43-.21,2.15-.32,1.44-.17,2.86-.42,4.31-.52,5.77-.43,11.57-.22,17.33.36,5.77.57,11.48,1.68,17.16,2.93,1.42.31,2.84.64,4.25,1.01,1.41.35,2.82.73,4.22,1.14,2.82.74,5.61,1.61,8.39,2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m972.39,275.87c-5.3-2.5-10.88-4.38-16.53-5.96-5.66-1.56-11.44-2.74-17.3-3.36-5.86-.55-11.79-.72-17.66.03-1.46.18-2.91.52-4.36.77-.72.15-1.45.24-2.16.44l-2.12.64c-2.85.76-5.51,2.08-8.14,3.34,2.8-.9,5.47-2.05,8.35-2.52l2.11-.5c.7-.17,1.43-.21,2.15-.32,1.44-.17,2.86-.42,4.31-.52,5.77-.43,11.57-.22,17.33.36,5.77.57,11.48,1.68,17.16,2.93,1.42.31,2.84.64,4.25,1.01,1.41.35,2.82.73,4.22,1.14,2.82.74,5.61,1.61,8.39,2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m969.13,283.31c-5.3-2.5-10.88-4.38-16.53-5.96-5.66-1.56-11.44-2.74-17.3-3.36-5.86-.55-11.79-.72-17.66.03-1.46.18-2.91.52-4.36.77-.72.15-1.45.24-2.16.44l-2.12.64c-2.85.76-5.51,2.08-8.14,3.34,2.8-.9,5.47-2.05,8.35-2.52l2.11-.5c.7-.17,1.43-.21,2.15-.32,1.44-.17,2.86-.42,4.31-.52,5.77-.43,11.57-.22,17.33.36,5.77.57,11.48,1.68,17.16,2.93,1.42.31,2.84.64,4.25,1.01,1.41.35,2.82.73,4.22,1.14,2.82.74,5.61,1.61,8.39,2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m965.87,290.75c-5.05-2.48-10.39-4.36-15.8-5.94-5.42-1.55-10.97-2.69-16.59-3.36-5.63-.51-11.33-.71-16.97.03-1.4.19-2.79.52-4.18.77-.69.15-1.4.23-2.07.45l-2.03.63c-2.73.76-5.26,2.08-7.77,3.32,2.68-.9,5.22-2.05,7.99-2.52l2.02-.5c.67-.17,1.37-.21,2.06-.32,1.38-.17,2.75-.42,4.13-.53,5.54-.45,11.11-.27,16.64.36,5.55.52,11.01,1.68,16.45,2.94,1.36.31,2.72.64,4.07,1.02,1.36.35,2.7.74,4.04,1.14,2.7.74,5.36,1.62,8.02,2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m962.75,298.18c-5.05-2.48-10.39-4.36-15.8-5.94-5.42-1.55-10.97-2.69-16.59-3.36-5.63-.51-11.33-.71-16.97.03-1.4.19-2.79.52-4.18.77-.69.15-1.4.23-2.07.45l-2.03.63c-2.73.76-5.26,2.08-7.77,3.32,2.68-.9,5.22-2.05,7.99-2.52l2.02-.5c.67-.17,1.37-.21,2.06-.32,1.38-.17,2.75-.42,4.13-.53,5.54-.45,11.11-.27,16.64.36,5.55.52,11.01,1.68,16.45,2.94,1.36.31,2.72.64,4.07,1.02,1.36.35,2.7.74,4.04,1.14,2.7.74,5.36,1.62,8.02,2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m959.63,305.62c-5.05-2.48-10.39-4.36-15.8-5.94-5.42-1.55-10.97-2.69-16.59-3.36-5.63-.51-11.33-.71-16.97.03-1.4.19-2.79.52-4.18.77-.69.15-1.4.23-2.07.45l-2.03.63c-2.73.76-5.26,2.08-7.77,3.32,2.68-.9,5.22-2.05,7.99-2.52l2.02-.5c.67-.17,1.37-.21,2.06-.32,1.38-.17,2.75-.42,4.13-.53,5.54-.45,11.11-.27,16.64.36,5.55.52,11.01,1.68,16.45,2.94,1.36.31,2.72.64,4.07,1.02,1.36.35,2.7.74,4.04,1.14,2.7.74,5.36,1.62,8.02,2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m955.98,312.89c-5.05-2.48-10.39-4.36-15.8-5.94-5.42-1.55-10.97-2.69-16.59-3.36-5.63-.51-11.33-.71-16.97.03-1.4.19-2.79.52-4.18.77-.69.15-1.4.23-2.07.45l-2.03.63c-2.73.76-5.26,2.08-7.77,3.32,2.68-.9,5.22-2.05,7.99-2.52l2.02-.5c.67-.17,1.37-.21,2.06-.32,1.38-.17,2.75-.42,4.13-.53,5.54-.45,11.11-.27,16.64.36,5.55.52,11.01,1.68,16.45,2.94,1.36.31,2.72.64,4.07,1.02,1.36.35,2.7.74,4.04,1.14,2.7.74,5.36,1.62,8.02,2.53Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m877.31,304.4c-5.11-5.3-11-9.84-17.2-13.85-6.19-4.04-12.85-7.35-19.7-10.14-3.41-1.44-6.99-2.44-10.5-3.59-3.61-.83-7.15-1.96-10.83-2.39-7.28-1.38-14.72-1.5-22.05-1.18,1.84.13,3.67.24,5.5.33,1.83.09,3.66.17,5.47.48l5.44.67c1.81.25,3.59.7,5.38,1.03,3.6.63,7.1,1.7,10.63,2.6,3.45,1.19,6.96,2.22,10.3,3.68,6.81,2.61,13.36,5.9,19.64,9.65,1.57.93,3.11,1.92,4.67,2.88,1.52,1.02,3.04,2.04,4.53,3.09,3.01,2.09,5.91,4.33,8.71,6.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m879.37,297.14c-4.82-5.22-10.41-9.73-16.31-13.73-5.9-4.02-12.27-7.32-18.83-10.13-3.27-1.45-6.71-2.45-10.09-3.61l-5.19-1.34c-.87-.21-1.72-.48-2.6-.63l-2.64-.43c-7.01-1.4-14.2-1.51-21.28-1.21,1.78.13,3.55.24,5.31.32l2.65.15c.88.04,1.75.23,2.63.33l5.25.67c1.74.27,3.46.7,5.18,1.04,3.47.63,6.83,1.72,10.23,2.61,3.31,1.19,6.68,2.23,9.88,3.7,6.53,2.63,12.8,5.91,18.78,9.65l4.45,2.87c1.44,1.02,2.9,2.02,4.31,3.08,2.87,2.07,5.62,4.3,8.27,6.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m881.44,289.87c-4.82-5.22-10.41-9.73-16.31-13.73-5.9-4.02-12.27-7.32-18.83-10.13-3.27-1.45-6.71-2.45-10.09-3.61l-5.19-1.34c-.87-.21-1.72-.48-2.6-.63l-2.64-.43c-7.01-1.4-14.2-1.51-21.28-1.21,1.78.13,3.55.24,5.31.32l2.65.14c.88.04,1.75.23,2.63.33l5.25.67c1.74.27,3.46.7,5.18,1.04,3.47.63,6.83,1.72,10.23,2.61,3.31,1.19,6.68,2.23,9.88,3.7,6.53,2.63,12.8,5.91,18.78,9.65l4.45,2.87c1.44,1.02,2.9,2.02,4.31,3.08,2.87,2.07,5.62,4.3,8.27,6.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m883.5,282.6c-4.82-5.22-10.41-9.73-16.31-13.73-5.9-4.02-12.27-7.32-18.83-10.13-3.27-1.45-6.71-2.45-10.09-3.61l-5.19-1.34c-.87-.21-1.72-.48-2.6-.63l-2.64-.43c-7.01-1.4-14.2-1.51-21.28-1.21,1.78.13,3.55.24,5.31.32l2.65.15c.88.04,1.75.23,2.63.33l5.25.67c1.74.27,3.46.7,5.18,1.04,3.47.63,6.83,1.72,10.23,2.61,3.31,1.19,6.68,2.23,9.88,3.7,6.53,2.63,12.8,5.91,18.78,9.65l4.45,2.87c1.44,1.02,2.9,2.02,4.31,3.08,2.87,2.07,5.62,4.3,8.27,6.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m887.3,275.14c-4.82-5.22-10.41-9.73-16.31-13.73-5.9-4.02-12.27-7.32-18.83-10.13-3.27-1.45-6.71-2.45-10.09-3.61l-5.19-1.34c-.87-.21-1.72-.48-2.6-.63l-2.64-.43c-7.01-1.4-14.2-1.51-21.28-1.21,1.78.13,3.55.24,5.31.32l2.65.14c.88.04,1.75.23,2.63.33l5.25.67c1.74.27,3.46.7,5.18,1.04,3.47.63,6.83,1.72,10.23,2.61,3.31,1.19,6.68,2.23,9.88,3.7,6.53,2.63,12.8,5.91,18.78,9.65l4.45,2.87c1.44,1.02,2.9,2.02,4.31,3.08,2.87,2.07,5.62,4.3,8.27,6.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m891.06,269.87c-4.82-5.22-10.41-9.73-16.31-13.73-5.9-4.02-12.27-7.32-18.83-10.13-3.27-1.45-6.71-2.45-10.09-3.61l-5.19-1.34c-.87-.21-1.72-.48-2.6-.63l-2.64-.43c-7.01-1.4-14.2-1.51-21.28-1.2,1.78.13,3.55.24,5.31.32l2.65.14c.88.04,1.75.23,2.63.33l5.25.67c1.74.27,3.46.7,5.18,1.04,3.47.63,6.83,1.72,10.23,2.61,3.31,1.19,6.68,2.23,9.88,3.7,6.53,2.63,12.8,5.91,18.78,9.65l4.45,2.87c1.44,1.02,2.9,2.02,4.31,3.08,2.87,2.07,5.62,4.3,8.27,6.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m893.12,262.6c-4.82-5.22-10.41-9.73-16.31-13.73-5.9-4.02-12.27-7.32-18.83-10.13-3.27-1.45-6.71-2.45-10.09-3.61l-5.19-1.34c-.87-.21-1.72-.48-2.6-.63l-2.64-.43c-7.01-1.4-14.2-1.51-21.28-1.21,1.78.13,3.55.24,5.31.32l2.65.14c.88.04,1.75.23,2.63.33l5.25.67c1.74.27,3.46.7,5.18,1.04,3.47.63,6.83,1.72,10.23,2.61,3.31,1.19,6.68,2.23,9.88,3.7,6.53,2.63,12.8,5.91,18.78,9.65l4.45,2.87c1.44,1.02,2.9,2.02,4.31,3.08,2.87,2.07,5.62,4.3,8.27,6.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m899.19,248.41c-4.62-5.16-9.99-9.64-15.67-13.63-5.69-4-11.85-7.31-18.22-10.13-3.17-1.44-6.51-2.47-9.8-3.62l-5.04-1.36c-.84-.21-1.68-.47-2.53-.64l-2.58-.44c-6.83-1.41-13.84-1.53-20.74-1.22,1.73.12,3.45.23,5.18.32l2.58.14c.86.05,1.71.23,2.56.33l5.11.67c1.69.28,3.36.7,5.04,1.05,1.68.34,3.35.72,5,1.22l4.95,1.41c3.22,1.18,6.48,2.25,9.59,3.71,6.33,2.64,12.39,5.93,18.17,9.65l4.29,2.87c1.38,1.02,2.79,2.01,4.15,3.07,2.77,2.06,5.41,4.28,7.96,6.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m902.5,241.78c-4.62-5.16-9.99-9.64-15.67-13.63-5.69-4-11.85-7.31-18.22-10.13-3.17-1.44-6.51-2.47-9.8-3.62l-5.04-1.36c-.84-.21-1.68-.47-2.53-.64l-2.58-.44c-6.83-1.41-13.84-1.53-20.74-1.22,1.73.12,3.45.23,5.18.32l2.58.14c.86.05,1.71.23,2.56.33l5.11.67c1.69.28,3.36.7,5.04,1.05,1.68.34,3.35.72,5,1.22l4.95,1.41c3.22,1.18,6.48,2.25,9.59,3.71,6.33,2.64,12.39,5.93,18.17,9.65l4.29,2.87c1.38,1.02,2.79,2.01,4.15,3.07,2.77,2.06,5.41,4.28,7.96,6.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m895.19,255.34c-4.67-5.18-10.09-9.66-15.82-13.65-5.74-4-11.95-7.31-18.36-10.13-3.2-1.44-6.56-2.47-9.86-3.62l-5.08-1.35c-.85-.21-1.69-.47-2.55-.64l-2.59-.43c-6.87-1.41-13.92-1.52-20.86-1.22,1.74.12,3.48.23,5.21.32l2.6.14c.86.05,1.72.23,2.58.33l5.15.67c1.7.28,3.39.7,5.08,1.04,1.69.35,3.38.71,5.03,1.22l4.98,1.41c3.24,1.18,6.53,2.24,9.66,3.71,6.37,2.64,12.48,5.92,18.31,9.65l4.33,2.87c1.39,1.02,2.82,2.01,4.19,3.07,2.79,2.06,5.46,4.28,8.03,6.62Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBibliotheekIcon);
export default __webpack_public_path__ + "static/media/bibliotheek-icon.89c485b31ce8117f850fc2b38278e022.svg";
export { ForwardRef as ReactComponent };